import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { RootState } from 'store';

import { searchHotelLocations } from 'actions/hotelLocations';
import HotelLocationsSearch from 'components/HotelLocationsSearch';
import { TravelHotelContentLocationRequest } from 'models/hotelLocation';

interface Props {
  show: boolean;
  placeHolder: string;
  onClose: () => void;
  onChange: (data?: TravelHotelContentLocationRequest) => void;
}

const HotelsLocationSearchContainer = (props: Props) => {
  const dispatch = useDispatch();
  const hotelLocations = useSelector((state: RootState) => state.hotelLocations);

  const handleSearchChange = _.debounce((value: string) => {
    if (value && value.length > 2) {
      dispatch(searchHotelLocations(value));
    }
  }, 250);

  return (
    <HotelLocationsSearch {...props} {...hotelLocations} minLengthForSearch={2} onSearchChange={handleSearchChange} />
  );
};

export default HotelsLocationSearchContainer;
